interface StyleConfig {
  key: string;
  title: string;
  description: string;
  additionalProps?: Record<string, any>;
  wrapper?: string;
  wrapperProps?: Record<string, any>;
}

interface StyleLayoutItem {
  gridSize: { xs: number; md?: number };
  components: StyleConfig[];
  wrapper?: string;
  wrapperProps?: Record<string, any>;
}

export const chatAnalyticsStyleLayout: StyleLayoutItem[] = [
  {
    gridSize: { xs: 12, md: 4 },
    components: [
      {
        key: 'chat_statistics_overview.total_messages',
        title: 'Total Messages',
        description: '',
        additionalProps: {}
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 4 },
    components: [
      {
        key: 'chat_statistics_overview.total_group_messages',
        title: 'Group Messages',
        description: '',
        additionalProps: {}
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 4 },
    components: [
      {
        key: 'chat_statistics_overview.total_peer_messages',
        title: 'Peer Messages',
        description: '',
        additionalProps: {}
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'messaging_activity_data',
        title: 'Messaging Activity',
        description: 'This chart displays the counts of messages sent, delivered, and read per day during the selected time frame',
        additionalProps: {
          dataKeys: ['sent', 'delivered', 'read'],
          height: 550,
          graphHeight: 420,
          xAxisKey: 'date',
          colors: ['#3B82F6', '#10B981', '#F59E0B'],
          xAxisTitle: 'Date',
          yAxisTitle: 'Number of Messages'
        }
      }
    ]
  },
  {
    gridSize: { xs: 6 },
    components: [
      {
        key: 'concurrent_message_sent_heatmap',
        title: 'Messages Sent',
        description: 'This heatmap indicates the hour of the day and the number of messages sent during that hour for the selected time frame.',
        additionalProps: {
          height: 550,
          graphHeight: 400,
          colorScale: { low: '#E0E7FF', medium: '#A78BFA', high: '#7C3AED' },
          xAxisLabel: 'Hour',
          yAxisLabel: 'Date'
        }
      }
    ]
  },
  {
    gridSize: { xs: 6 },
    components: [
      {
        key: 'concurrent_message_delivered_heatmap',
        title: 'Messages Delivered',
        description: 'This heatmap indicates the hour of the day and the number of messages delivered during that hour for the selected time frame.',
        additionalProps: {
          height: 550,
          graphHeight: 400,
          colorScale: { low: '#E0E7FF', medium: '#A78BFA', high: '#7C3AED' },
          xAxisLabel: 'Hour',
          yAxisLabel: 'Date'
        }
      }
    ]
  },
  {
    gridSize: { xs: 6 },
    components: [
      {
        key: 'concurrent_message_read_heatmap',
        title: 'Messages Read',
        description: 'This heatmap indicates the hour of the day and the number of messages read during that hour for the selected time frame.',
        additionalProps: {
          height: 550,
          graphHeight: 400,
          colorScale: { low: '#E0E7FF', medium: '#A78BFA', high: '#7C3AED' },
          xAxisLabel: 'Hour',
          yAxisLabel: 'Date'
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'chat_trends_data',
        title: 'Messages By Conversation Type',
        description: 'This graph shows the volume of user-to-user messages and group messages per day during the selected time frame',
        additionalProps: {
          dataKeys: ['group', 'user'],
          xAxisKey: 'date',
          colors: ['#7C3AED', '#F59E0B'],
          xAxisTitle: 'Date',
          yAxisTitle: 'Message count',
          height: 550,
          graphHeight: 420
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'top_10_days_by_sent_messages',
        title: 'Top Days by Messages Sent',
        description: 'This graph shows the top 10 days with the highest number of messages sent during the selected time frame',
        additionalProps: {
          dataKeys: ['sent_count'],
          xAxisKey: 'date',
          colors: ['#3B82F6'],
          xAxisTitle: 'Date',
          yAxisTitle: 'Messages count',
          height: 550,
          graphHeight: 420
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'message_type_distribution',
        title: 'Message Types Distribution',
        description: 'Distribution of message types such as text, audio, etc.',
        additionalProps: { 
          height: 490,
          graphHeight: 380
         }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    wrapper: 'Stack',
    wrapperProps: { spacing: 2, direction: 'column', sx: { height: '100%' } },
    components: [
      {
        key: 'chat_statistics_overview.total_sent',
        title: 'Total Sent',
        description: '',
        additionalProps: {
          compact: true,
          valueFontSize: '2rem',
          titleFontSize: '0.75rem',
          descriptionFontSize: '0.7rem'
        }
      },
      {
        key: 'chat_statistics_overview.total_delivered',
        title: 'Total Delivered',
        description: '',
        additionalProps: {
          compact: true,
          valueFontSize: '2rem',
          titleFontSize: '0.75rem',
          descriptionFontSize: '0.7rem'
        }
      },
      {
        key: 'chat_statistics_overview.total_read',
        title: 'Total Read',
        description: '',
        additionalProps: {
          compact: true,
          valueFontSize: '2rem',
          titleFontSize: '0.75rem',
          descriptionFontSize: '0.7rem'
        }
      }
    ],
  }
];